import cx from 'classnames';
import { Tab } from 'semantic-ui-react';
import Tabs from './Tabs';

const Body = ({ data }) => {
  return (
    <div className="block-content">
      <Tab panes={Tabs(data)} menu={{ secondary: true, pointing: true }} />
    </div>
  );
};

export default Body;
